<template>
    <v-card-text class="pa-0" :class="{ 'mt-3 px-2': $bp.xsOnly }">
        <app-section-loader :status="section_loader"></app-section-loader>
        <v-container class="pb-0">
            <v-layout row wrap class="pb-0" v-if="current_group">
                <v-flex xs12 sm3 pa-0>
                    <v-layout inner-layout column fill-height>
                        <v-flex hidden-xs-only border border-left-0 border-top-0 border-bottom-0 unselectable shrink style="height: 5vh"> &nbsp; </v-flex>
                        <v-flex
                            :class="
                                current_active == i
                                    ? 'border-red-left-2 border border-left-2 border-right-0'
                                    : 'border border-left-0 border-top-0 border-bottom-0 grey--text'
                            "
                            v-for="(g, i) in allowed_group_options"
                            :key="i"
                            class="fs-14 clickable hover-black-text px-2 py-3 unselectable text-uppercase shrink"
                            @mouseup.left="current_active = i"
                        >
                            <v-layout row inner-layout>
                                <v-flex style="max-width: 30px" ml-2>
                                    <v-icon>{{ g.icon }}</v-icon>
                                </v-flex>
                                <v-flex style="position: relative; bottom: -5px; left: -10px">
                                    {{ g.text }}
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex grow hidden-xs-only border border-left-0 border-top-0 border-bottom-0 unselectable pb-0> &nbsp; </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12 sm9 pb-0 :class="{ 'px-0': $bp.xsOnly }">
                    <div class="h-100">
                        <v-layout row wrap :class="$bp.xsOnly ? 'py-3 px-0' : 'px-3 pt-3 pb-0'">
                            <v-flex xs12 text-center px-0 pb-1>
                                <v-layout row wrap pb-2>
                                    <v-flex xs12 fs-22 text-uppercase pa-0>
                                        {{ current_group.text }}
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 :class="{ 'px-0': $bp.xsOnly }">
                                <v-data-table
                                    v-if="current_group.view == 'packing_list'"
                                    v-model="selected_options"
                                    :headers="headers"
                                    :items="format_packing_list_fields"
                                    item-key="value"
                                    :no-data-text="$t('lang.no_results_matching')"
                                    hide-actions
                                    select-all
                                >
                                    <template slot="headers" slot-scope="props">
                                        <tr @click.stop="toggleAll">
                                            <th style="width: 30px">
                                                <v-checkbox
                                                    color="primary"
                                                    hide-details
                                                    :input-value="props.all"
                                                    :indeterminate="props.indeterminate"
                                                    @click.stop="toggleAll"
                                                ></v-checkbox>
                                            </th>
                                            <th v-for="header in props.headers" :key="`header-${header.text}`" class="column text-left">
                                                {{ header.text }}
                                            </th>
                                        </tr>
                                    </template>
                                    <template slot="items" slot-scope="props">
                                        <tr class="clickable no-stripe" @click.stop="props.selected = !props.selected">
                                            <td class="pr-0" style="max-width: 25px">
                                                <v-checkbox
                                                    @click.stop="props.selected = !props.selected"
                                                    :input-value="props.selected"
                                                    primary
                                                    hide-details
                                                ></v-checkbox>
                                            </td>
                                            <td>{{ props.item.value }}</td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-flex>
                            <v-flex>
                                <v-btn
                                    v-if="hasPerm('packing_lists.update')"
                                    class="ml-auto"
                                    color="success"
                                    :disabled="
                                        (selected_options || []).length == 0 ||
                                        (options_before.length == selected_options.length &&
                                            options_before.every((option) => selected_options.map((o) => o.value).includes(option.value)))
                                    "
                                    @mouseup.left="modifyPackingList()"
                                >
                                    {{ $t("lang.save") }}
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-flex>
            </v-layout>
            <v-layout v-else>
                <v-flex class="text-center align-content-center" :style="$bp.smallScreen ? 'margin-top:16px;' : 'height:calc(100vh - 300px)'">
                    <span class="blue-grey--text text--lighten-4 display-1">{{ "No available settings" }}</span>
                </v-flex>
            </v-layout>
        </v-container>
    </v-card-text>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "settings",
    data() {
        return {
            section_loader: false,
            selected_options: null,
            current_active: 0,
            options_before: null,
            group_options: [{ text: "Packing List", icon: "description", view: "packing_list", perms: ["packing_lists.read"] }],
            parts: [],
            settings: {
                maxScrollbarLength: 150,
            },
            table_loader: true,
            format_packing_list_fields: [],
            headers: [{ text: "Field", sortable: false }],
        };
    },
    computed: {
        ...mapState({
            profile: (state) => state.customers.selectedCustomer,
            packing_list_fields_options: (state) => state.customers.packing_list_fields_options,
        }),
        allowed_group_options() {
            return this.group_options && this.group_options.length > 0
                ? this.group_options.filter((option) => !option.perms || (option.perms && option.perms.every((perm) => this.hasPerm(perm))))
                : [];
        },
        current_group() {
            return this.allowed_group_options[this.current_active];
        },
    },
    mounted: function () {
        this.format_packing_list_fields = this.packing_list_fields_options.map((p) => ({ value: p }));
        let prep_customers = this.profile && this.profile.packing_list_fields ? this.profile.packing_list_fields.map((p) => ({ value: p })) : [];
        this.selected_options = [...prep_customers];
        this.options_before = [...this.selected_options];
    },
    methods: {
        toggleAll() {
            if (this.selected_options.length) this.selected_options = [];
            else this.selected_options = this.format_packing_list_fields.slice();
        },
        modifyPackingList() {
            this.section_loader = true;
            this.options_before = [...this.selected_options];
            this.$store
                .dispatch("saveCustomer", {
                    url: `customers/${this.$route.params.id}`,
                    method: "patch",
                    stateProperty: "customer|entity_phones|entity_addresses|entity_emails",
                    dataProperty: "customer|customer.entity_phones|customer.entity_addresses|customer.entity_emails",
                    commit: true,
                    body: {
                        company_id: this.$route.params.id,
                        packing_list_fields: this.selected_options.map((o) => o.value),
                    },
                })
                .then((data) => {
                    this.section_loader = false;
                });
        },
    },
};
</script>
